import React from 'react'

const Tooltip = ({ text }) => {
  return (
    <div className="tooltip">
        <span style={{ fontSize: "12px", color: "rgba(0,0,0,1)" }} class="material-symbols-outlined">
            info
        </span>
        <span className="tooltiptext">{text}</span>
    </div>
  )
}

export default Tooltip